import React from 'react';
import { DataGrid as MuiDataGrid } from '@mui/x-data-grid';
import { usePaginationState } from '../../hooks/usePaginationState';

// Wrapper around MUI DataGrid which adds default pagination settings
// and automatically persists page/pageSize in sessionStorage using
// the current pathname (or an explicit storageKey prop).
//
// Props are forwarded through to the real DataGrid. If the caller
// already specifies paginationModel/onPaginationModelChange those will
// be merged so existing behaviour continues to work.

const PersistentDataGrid = ({ storageKey, pageSizeOptions, rowsPerPageOptions, paginationModel: pmProp, onPaginationModelChange: onPmChangeProp, ...rest }) => {
    const key = storageKey || `datagrid_${window.location.pathname}`;
    const [paginationModel, handlePaginationModelChange] = usePaginationState(key, { pageSize: 50, page: 0 });

    const mergedPaginationModel = pmProp || paginationModel;
    const mergedOnPaginationModelChange = (newModel) => {
        handlePaginationModelChange(newModel);
        if (onPmChangeProp) {
            onPmChangeProp(newModel);
        }
    };

    return (
        <MuiDataGrid
            {...rest}
            paginationModel={mergedPaginationModel}
            onPaginationModelChange={mergedOnPaginationModelChange}
            pageSizeOptions={pageSizeOptions || [10, 15, 25, 50]}
            rowsPerPageOptions={rowsPerPageOptions || [10, 20, 25, 50, 100]}
        />
    );
};

export default PersistentDataGrid;